import $ from "jquery"

const form = $('#ct-ultimate-gdpr-data-access');
const submitBtn = form.find('input[type=submit]');
const emailInput = form.find('input[type=email]');
const emailValue = emailInput.val();
const invalid = form.find('.invalid');
var isSubmit = false;
var responseResult = 'Please fill out this field.';

function validateEmail(email) {
    var emailRegEx = /\S+@\S+\.\S+/;
    return emailRegEx.test(email);
}

emailInput.on('keyup paste', function(){
    if (emailValue == '' && !validateEmail($(this).val())) {
        responseResult = 'Please enter an email address.';
        $(this).addClass('has-error');
        invalid.text(responseResult);
    } else {
        $(this).removeClass('has-error');
        invalid.text('');
    }
});

submitBtn.on('click', function() {
    const checkbox = $(this).parents('form').find('input[type="checkbox"]');
    const email = $(this).siblings('input[type="email"]');

    if (!checkbox.is(':checked')) {
        checkbox.addClass('has-error');
    }

    if (email.val() == '') {
        email.addClass('has-error');
        invalid.text(responseResult);
    } else {
        email.removeClass('has-error');
        invalid.text('');
    }

    isSubmit = true;
    checkSubmit(checkbox);
});

function checkSubmit(checkbox) {
    if (isSubmit) {
        checkbox.on('click', function() {
            if ($(this).is(':checked')) {
                $(this).addClass('has-error');
            } else {
                $(this).removeClass('has-error');
            }
        });
    }
}

const targetNode = document.querySelector('.ct-ultimate-gdpr-container');

const config = {
  attributes: true, 
  childList: true, 
  characterData: true
};
  
const callback = mutations => {  
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
        const listValues = Array.from(targetNode.children)
            .map(node => node.innerHTML)
            .filter(html => html !== '<br>');
            if (listValues[0] == 'Your request was sent!') {
                $('.js-contact-thankyou, .js-contact-thankyou-overlay').show();
                $('.ct-ultimate-gdpr-container .notice-info').hide();
            }
    }
  });
}

const observer = new MutationObserver(callback);

observer.observe(targetNode, config);
